import React from "react";

const AddBrandNew = () => {
  return <div>this is BranNew</div>;
};

export default React.memo(AddBrandNew);
